<template>
  <v-card flat>
    <v-layout class="admin-sub-title mb-2">{{title}}</v-layout>
    <v-layout
      v-for="item in data"
      :key="item.title"
      class="admin-content"
      column
      ml-2
    >
      <v-layout row>
        <v-flex
          lg5
          md5
          style="font-weight:350"
          mb-1
        >
          {{item.title}}
        </v-flex>
        <v-flex
          lg7
          md7
          style="font-weight:500"
          mb-1
        >
          {{item.data}}
        </v-flex>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<style lang="scss" scoped>
.admin-sub-title {
  font-size: 17px;
  font-weight: 650;
  color: black;
}
.admin-content {
  font-size: 15px;
  font-weight: 650;
  color: black;
}
</style>
<script>
export default {
  name: 'FileCard',
  props: {
    title: {
      type: String,
      default: 'NO TITLE PROVIDED'
    },
    data: {
      type: Array,
      default: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/InformationCard.vue